import React, { useEffect, useState, forwardRef } from "react";
import { useDropzone } from "react-dropzone";
import Dropzone from "react-dropzone";

import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";

const DropZone = forwardRef(
  (
    {
      options = {},
      handleOnChange = () => {},
      style = {},
      MAX_FILE_SIZE = 40,
      message = "Drag and drop image here or click the space to upload, or input prompts below in the text box to generate a new image",
      icon,
      sx = {},
    },
    ref
  ) => {
    const handleDropRejected = (files) => {
      let message = "";
      let fileName = "";
      for (let i = 0; i < files.length; i++) {
        const { errors, file } = files[i];
        if (errors) {
          fileName = file.name;
          for (let j = 0; j < errors.length; j++) {
            if (errors[j]?.code == "file-too-large") {
              message = `File:${fileName} is larger than ${MAX_FILE_SIZE}MB!`;
            } else {
              message = errors[j]?.message;
            }
          }
        }
      }
      if (message) {
        toast.error(message);
      }
    };

    const handleOnDrop = (acceptedFiles) => {
      let newFiles = [
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        ),
      ];
      handleOnChange(newFiles);
    };

    if (!options.onDropRejected) options.onDropRejected = handleDropRejected;
    if (!options.onDrop) options.onDrop = handleOnDrop;
    if (!options.maxSize) options.maxSize = MAX_FILE_SIZE * 1024 * 1024;
    if (!options.noKeyboard) options.noKeyboard = false;
    if (!options.accept) options.accept = {};
    options.multiple = false;

    return (
      <Dropzone ref={ref} {...options}>
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps({
              className: "dropzone cursor-pointer z-2",
            })}
            style={{
              border: "2px dashed gray",
              borderRadius: "15px",
              margin: "0 4px",
              width: "100%",
              height: "100%",
              overflowX: "auto",
              overflowY: "hidden",
              ...style,
            }}
          >
            <SuiBox
              sx={{
                margin: "auto",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                ...sx,
              }}
            >
              <input {...getInputProps()} />
              <SuiBox>
                {icon ? (
                  icon
                ) : (
                  <svg
                    class="w-16 h-16 mb-4 text-gray-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                )}
              </SuiBox>
              <SuiTypography variant="text" fontWeight="medium" color="secondary">
                {message}
              </SuiTypography>
            </SuiBox>
          </div>
        )}
      </Dropzone>
    );
  }
);
export default DropZone;
